/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { Accordion } from '@neo4j-ndl/react';
import { useState } from 'react';

type AccordionItemId = React.ComponentProps<typeof Accordion.Item>['itemId'];

const Component = () => {
  const itemIds = ['item-1', 'item-2', 'item-3', 'item-4'];

  const [expandedItemId, setExpandedItemId] = useState<AccordionItemId | null>(
    undefined,
  );

  const onChange = (expandedItemId: AccordionItemId | null) =>
    setExpandedItemId(expandedItemId);

  return (
    <Accordion
      expandedItemId={expandedItemId}
      isMultiple={undefined}
      onChange={onChange}
    >
      <Accordion.Item itemId={itemIds[0]} title={`Accordion ${itemIds[0]}`}>
        {itemIds[0]}
      </Accordion.Item>
      <Accordion.Item itemId={itemIds[1]} title={`Accordion ${itemIds[1]}`}>
        {itemIds[1]}
      </Accordion.Item>
      <Accordion.Item itemId={itemIds[2]} title={`Accordion ${itemIds[2]}`}>
        {itemIds[2]}
      </Accordion.Item>
      <Accordion.Item itemId={itemIds[3]} title={`Accordion ${itemIds[3]}`}>
        {itemIds[3]}
      </Accordion.Item>
    </Accordion>
  );
};

export default Component;
